import { Box, IconButton, useTheme } from "@mui/material";
import { useContext } from "react";
import { ColorModeContext } from "../../theme";

import LightModeOutlineIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlineIcon from "@mui/icons-material/DarkModeOutlined";

const Topbar = () => {
  const theme = useTheme();

  const colorMode = useContext(ColorModeContext);

  return (
    <Box display="flex" justifyContent="space-between" p={2}>
      <Box display="flex">
        {/* <img alt="profile-user" width="210px" height="50px" src={ImageLogo} /> */}
        <Box
          display="flex"
          alignItems="center"
          sx={{ width: "220px", height: "auto" }}
        >
          <img
            src="/logo.jpg"
            alt="Logo"
            style={{
              width: "100%",
              height: "auto",
            }}
          />
        </Box>
      </Box>
      <Box display="flex">
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "light" ? (
            <DarkModeOutlineIcon />
          ) : (
            <LightModeOutlineIcon />
          )}
        </IconButton>
      </Box>
    </Box>
  );
};
export default Topbar;
